import {
  REQUEST_DEVICE,
  RESPONSE_DEVICE,
  REQUEST_DEVICE_FAILURE,
  REQUEST_UPDATE_DEVICE,
  RESPONSE_UPDATE_DEVICE,
  REQUEST_UPDATE_DEVICE_FAILURE,
  REQUEST_CREATE_CONNECTED_SENSOR,
  RESPONSE_CREATE_CONNECTED_SENSOR,
  REQUEST_CREATE_CONNECTED_SENSOR_FAILURE,
  REQUEST_DELETE_CONNECTED_SENSOR,
  RESPONSE_DELETE_CONNECTED_SENSOR,
  REQUEST_DELETE_CONNECTED_SENSOR_FAILURE,
  REQUEST_CREATE_CALEBRATION,
  RESPONSE_CREATE_CALEBRATION,
  REQUEST_CREATE_CALEBRATION_FAILURE,
  REQUEST_DELETE_CALEBRATION,
  RESPONSE_DELETE_CALEBRATION,
  REQUEST_DELETE_CALEBRATION_FAILURE,
  REQUEST_REPLACE_DEVICE,
  RESPONSE_REPLACE_DEVICE,
  REQUEST_REPLACE_DEVICE_FAILURE,
  CLEAR_CURRENT_DEVICE,
  REQUEST_UPLOAD_CALIBRATIONS,
  RESPONSE_UPLOAD_CALIBRATIONS,
  REQUEST_UPLOAD_CALIBRATIONS_FAILURE,
  REQUEST_CREATE_DEVICE_COMMAND,
  RESPONSE_CREATE_DEVICE_COMMAND,
  REQUEST_CREATE_DEVICE_COMMAND_FAILURE,
  REQUEST_DELETE_DEVICE_COMMAND,
  RESPONSE_DELETE_DEVICE_COMMAND,
  REQUEST_DELETE_DEVICE_COMMAND_FAILURE,
} from "../actions/devicesAction";

import { states } from "./queriesStates";

const initialState = {
  currentDeviceDataState: states.NOT_REQUESTED,
  currentDeviceUpdateDataState: states.NOT_REQUESTED,
  createConnectedSensorDataState: states.NOT_REQUESTED,
  deleteConnectedSensorDataState: states.NOT_REQUESTED,
  createCalibrationDataState: states.NOT_REQUESTED,
  deleteCalibrationDataState: states.NOT_REQUESTED,
  uploadCalibrationsDataState: states.NOT_REQUESTED,
  createCommandDataState: states.NOT_REQUESTED,
  deleteCommandDataState: states.NOT_REQUESTED,
  currentDevice: null,
  protocolMarkers: null,
  errors: [],
};

const currentDeviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DEVICE:
      return Object.assign({}, state, {
        currentDeviceDataState: states.REQUEST,
        currentDevice: null,
      });
    case RESPONSE_DEVICE:
      return Object.assign({}, state, {
        currentDeviceDataState: states.READY,
        currentDevice: action.data,
      });
    case REQUEST_DEVICE_FAILURE:
      return Object.assign({}, state, {
        currentDeviceDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UPDATE_DEVICE:
      return Object.assign({}, state, {
        currentDeviceUpdateDataState: states.REQUEST,
      });
    case RESPONSE_UPDATE_DEVICE:
      const device = state.currentDevice;

      device.phone = action.data.phone;
      device.numberSim = action.data.numberSim;
      device.type = action.data.type;
      device.model = action.data.model;
      device.guaranteeStartDate = action.data.guaranteeStartDate;
      device.guaranteeMounths = action.data.guaranteeMounths;

      return Object.assign({}, state, {
        currentDeviceUpdateDataState: states.READY,
        currentDevice: device,
      });
    case REQUEST_UPDATE_DEVICE_FAILURE:
      return Object.assign({}, state, {
        currentDeviceUpdateDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_CONNECTED_SENSOR:
      return Object.assign({}, state, {
        createConnectedSensorDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_CONNECTED_SENSOR:
      const currentDevice = state.currentDevice;
      currentDevice.connectedSensors = currentDevice.connectedSensors.concat({ ...action.data, calibrations: [] });

      return Object.assign({}, state, {
        createConnectedSensorDataState: states.READY,
        currentDevice: currentDevice,
      });
    case REQUEST_CREATE_CONNECTED_SENSOR_FAILURE:
      return Object.assign({}, state, {
        createConnectedSensorDataState: states.FAILURE,
        errors: action.errors.deviceInPut,
      });

    case REQUEST_DELETE_CONNECTED_SENSOR:
      return Object.assign({}, state, {
        deleteConnectedSensorDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_CONNECTED_SENSOR:
      const deleteConnectedSensor = state.currentDevice;
      deleteConnectedSensor.connectedSensors = deleteConnectedSensor.connectedSensors.filter((x) => {
        return x.id !== action.data;
      });

      return Object.assign({}, state, {
        deleteConnectedSensorDataState: states.READY,
        currentDevice: deleteConnectedSensor,
      });
    case REQUEST_DELETE_CONNECTED_SENSOR_FAILURE:
      return Object.assign({}, state, {
        deleteConnectedSensorDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_CALEBRATION:
      return Object.assign({}, state, {
        createCalibrationDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_CALEBRATION:
      const createCalibration = state.currentDevice;
      createCalibration.connectedSensors.forEach((connectedSensor) => {
        if (connectedSensor.id === action.data.id) {
          connectedSensor.calibrations = connectedSensor.calibrations
            .concat(action.data.calibration)
            .sort((a, b) => (a.inValue > b.inValue ? 1 : -1));
        }
      });

      return Object.assign({}, state, {
        createCalibrationDataState: states.READY,
        currentDevice: createCalibration,
      });
    case REQUEST_CREATE_CALEBRATION_FAILURE:
      return Object.assign({}, state, {
        createCalibrationDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_CALEBRATION:
      return Object.assign({}, state, {
        deleteCalibrationDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_CALEBRATION:
      const deleteCalibration = state.currentDevice;

      deleteCalibration.connectedSensors.forEach((connectedSensor) => {
        if (connectedSensor.id === action.data.id) {
          connectedSensor.calibrations = connectedSensor.calibrations
            .filter((x) => {
              return x.id !== action.data.calibrationId;
            })
            .sort((a, b) => (a.inValue > b.inValue ? 1 : -1));
        }
      });

      return Object.assign({}, state, {
        deleteCalibrationDataState: states.READY,
        currentDevice: deleteCalibration,
      });
    case REQUEST_DELETE_CALEBRATION_FAILURE:
      return Object.assign({}, state, {
        deleteCalibrationDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_REPLACE_DEVICE:
      return Object.assign({}, state, {
        replaceDeviceDataState: states.REQUEST,
      });
    case RESPONSE_REPLACE_DEVICE:
      return Object.assign({}, state, {
        replaceDeviceDataState: states.READY,
      });
    case REQUEST_REPLACE_DEVICE_FAILURE:
      return Object.assign({}, state, {
        replaceDeviceDataState: states.FAILURE,
        errors: action.errors,
      });

    case CLEAR_CURRENT_DEVICE:
      return Object.assign({}, state, {
        currentDevice: null,
      });

    case REQUEST_UPLOAD_CALIBRATIONS:
      return Object.assign({}, state, {
        uploadCalibrationsDataState: states.REQUEST,
      });
    case RESPONSE_UPLOAD_CALIBRATIONS:
      const _currentDevice = state.currentDevice;

      _currentDevice.connectedSensors.forEach((item) => {
        if (item.id === action.id) {
          item.calibrations = action.data.calibrations;
        }
      });

      return Object.assign({}, state, {
        uploadCalibrationsDataState: states.READY,
        currentDevice: _currentDevice,
      });
    case REQUEST_UPLOAD_CALIBRATIONS_FAILURE:
      return Object.assign({}, state, {
        uploadCalibrationsDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_DEVICE_COMMAND:
      return Object.assign({}, state, {
        createCommandDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_DEVICE_COMMAND:
      const __currentDevice = state.currentDevice;
      __currentDevice.command = action.data.command;

      return Object.assign({}, state, {
        createCommandDataState: states.READY,
        currentDevice: __currentDevice,
      });
    case REQUEST_CREATE_DEVICE_COMMAND_FAILURE:
      return Object.assign({}, state, {
        createCommandDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_DEVICE_COMMAND:
      return Object.assign({}, state, {
        deleteCommandDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_DEVICE_COMMAND:
      const ___currentDevice = state.currentDevice;
      ___currentDevice.command = null;

      return Object.assign({}, state, {
        deleteCommandDataState: states.READY,
        currentDevice: ___currentDevice,
      });
    case REQUEST_DELETE_DEVICE_COMMAND_FAILURE:
      return Object.assign({}, state, {
        deleteCommandDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default currentDeviceReducer;
